<template>
  <div>

  </div>
</template>


<script>
import Http from '@/libs/http';


export default {
  data() {
    return {};
  },
  mounted() {
    // url上会携带card_code，insuranceId两个参数
    const { card_code, insuranceId } = this.$route.query;
    if (!card_code || !insuranceId) return;
    window.opener.postMessage({ card_code, insuranceId }, '*');
    // 发送接口
    this.ensureInsuranceApplicant(card_code, +insuranceId);
  },
  methods: {
    ensureInsuranceApplicant(card_code, insurance_id) {
      Http.post('/insurance_applicant_ensure', {
        card_code,
        insurance_id,
      }).then(() => {
        window.close();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/confirm-post-message.vue